import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-circle",
  "use": "close-circle-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"close-circle\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"11\" cy=\"11\" r=\"11\" fill=\"#A4A4AD\" /><path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 7l-8 8m0-8l8 8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol